export default __webpack_public_path__ + "static/media/Passenger Car Transport.1a6c0d3e.pdf";